import { ShipmentType } from '../enums/_index';
import { ShipmentSummary } from '../shipments/shipment-summary';

export class TruckSummary extends ShipmentSummary {

    constructor() {
        super(ShipmentType.Truck);
    }

}
